import TypeformUrls from "../typeform/TypeformUrls";

const KnowledgeBaseContent = [
  /*{
    key: 'balance_sheet',
    title: 'Balance Sheet',
    url: TypeformUrls.BALANCE_SHEET,
    order: 10000,
  },
  {
    key: 'capital_budgeting',
    title: 'Capital Budgeting',
    url: TypeformUrls.CAPITAL_BUDGETING,
    order: 10000,
  },
  {
    key: 'capital_structure',
    title: 'Capital Structure',
    url: TypeformUrls.CAPITAL_STRUCTURE,
    order: 10000,
  },
  {
    key: 'cash_flows',
    title: 'Cash Flows',
    url: TypeformUrls.CASH_FLOWS,
    order: 10000,
  },
  {
    key: 'cost_of_capital',
    title: 'Cost of Capital',
    url: TypeformUrls.COST_OF_CAPITAL,
    order: 10000,
  },
  {
    key: 'debt_vs_equity',
    title: 'Debt vs Equity',
    url: TypeformUrls.DEBT_VS_EQUITY,
    order: 10000,
  },
  {
    key: 'debt_to_capital',
    title: 'Debt to Capital',
    url: TypeformUrls.DEBT_TO_CAPITAL,
    order: 10000,
  },
  {
    key: 'discount_rate',
    title: 'Discount Rate',
    url: TypeformUrls.DISCOUNT_RATE,
    order: 10000,
  },
  {
    key: 'dividend_yield',
    title: 'Dividend Yield',
    url: TypeformUrls.DIVIDEND_YIELD,
    order: 10000,
  },
  {
    key: 'earnings_per_share',
    title: 'Earnings Per Share',
    url: TypeformUrls.EARNINGS_PER_SHARE,
    order: 10000,
  },
  {
    key: 'earnings_yield',
    title: 'Earnings Yield',
    url: TypeformUrls.EARNINGS_YIELD,
    order: 10000,
  },*/
  {
    title: "Financial Metrics",
    url: TypeformUrls.FINANCIAL_METRICS,
    order: 2
  },
  /*{
    key: 'financial_projections',
    title: 'Financial Projections',
    url: TypeformUrls.FINANCIAL_PROJECTIONS,
    order: 10000,
  },
  {
    key: 'financial_planning_analysis',
    title: 'Financial Planning & Analysis',
    url: TypeformUrls.FINANCIAL_ANALYSIS,
    order: 10000,
  },*/
  {
    key: "financials",
    title: "Financials",
    url: TypeformUrls.FINANCIALS,
    order: 1
  }
  /*{
    key: 'income_statement',
    title: 'Income Statement',
    url: TypeformUrls.INCOME_STATEMENT,
    order: 10000,
  },
  {
    key: 'irr',
    title: 'IRR',
    url: TypeformUrls.IRR,
    order: 10000,
  },
  {
    key: 'issuing_shares',
    title: 'Issuing Shares',
    url: TypeformUrls.SHARES_OUTSTANDING,
    order: 10000,
  },
  {
    key: 'kpi',
    title: 'KPIs',
    url: TypeformUrls.KPI,
    order: 10000,
  },
  {
    key: 'marketing_mix',
    title: 'Marketing Mix',
    url: TypeformUrls.MARKETING_MIX,
    order: 10000,
  },
  {
    key: 'marketing_funnel',
    title: 'Marketing Funnel',
    url: TypeformUrls.MARKETING_FUNNEL,
    order: 10000,
  },
  {
    key: 'product_market_fit',
    title: 'Product Market Fit',
    url: TypeformUrls.PRODUCT_MARKET_FIT,
    order: 10000,
  },
  {
    key: 'product_costs',
    title: 'Product Costs',
    url: TypeformUrls.PRODUCT_COSTS,
    order: 10000,
  },
  {
    key: 'product_lifecycle',
    title: 'Product Lifecycle',
    url: TypeformUrls.PRODUCT_LIFECYCLE,
    order: 10000,
  },
  {
    key: 'roic',
    title: 'Return on Invested Capital',
    url: TypeformUrls.ROIC,
    order: 10000,
  },
  {
    key: 'rnoa',
    title: 'Return on Net Operating Assets',
    url: TypeformUrls.RNOA,
    order: 10000,
  },
  {
    key: 'stock_price',
    title: 'Stock Price',
    url: TypeformUrls.STOCK_PRICE,
    order: 10000,
  },
  {
    key: 'time_value_of_money',
    title: 'Time Value of Money',
    url: TypeformUrls.TIME_VALUE_OF_MONEY,
    order: 10000,
  },
  {
    key: 'utilization',
    title: 'Utilization',
    url: TypeformUrls.UTILIZATION,
    order: 10000,
  },
  {
    key: 'business_valuation',
    title: 'Business Valuation',
    url: TypeformUrls.BUSINESS_VALUATION,
    order: 10000,
  },
  {
    key: 'working_capital',
    title: 'Working Capital',
    url: TypeformUrls.WORKING_CAPITAL,
    order: 10000,
  }*/
];

export default KnowledgeBaseContent;



// WEBPACK FOOTER //
// ./src/components/knowledge-base/KnowledgeBaseContent.js